import CompPlanService from "@/services/bytepro/compPlan.service";

export const compPlanApi = {
  namespaced: true,
  state: {},
  getters: {},
  actions: {
    get({ commit }, compPlanId) {
      return CompPlanService.get(compPlanId).then(
        (resp) => {
          commit("dummyConsole", "CompPlanService.get - success");
          return Promise.resolve(resp);
        },
        (error) => {
          commit("dummyConsole", "CompPlanService.get - error");
          return Promise.reject(error);
        }
      );
    },
  },
  mutations: {
    dummyConsole(state, obj) {
      console.log(obj);
    },
  },
};
